import { Injectable } from '@angular/core';
import { ApiService } from 'core/api/api.service';
import { Product } from '../../modules/pos/quotes/entities/products.class';
import { QuoteToolsService } from '../../modules/pos/quotes/services/quote-tools.service';
import { prioritizeNotifications } from './product-notification-priority';
import { TooltipNotification } from './tooltip-notification.class';

@Injectable({
  providedIn: 'root'
})
export class TooltipNotificationService {
  buttons = new Map([
    ['empty', null],
    ['remove',
      {
        class: 'primary',
        callbackType: 'remove',
        label: 'Remove'
      }
    ],
    ['supersede',
      {
        class: '',
        callbackType: 'supersede',
        label: 'Replace'
      }
    ],
    ['ignore',
      {
        class: 'primary',
        callbackType: 'ignore',
        label: 'Ignore'
      }
    ],
    ['oemSku',
      {
        class: 'primary',
        callbackType: 'oemSku',
        label: 'Ok'
      }
    ],
    ['edit',
      {
        class: '',
        callbackType: 'edit',
        label: 'Edit'
      }
    ],
    ['update',
      {
        class: 'primary',
        callbackType: 'update',
        label: 'Update'
      }
    ]
  ]);

  messageButtons = new Map([
    ['NotFound', [this.buttons.get('remove')]],
    ['Discontinued', [this.buttons.get('remove')]],
    ['Restricted', [this.buttons.get('remove')]],
    ['MultipleOemSkuItems', [this.buttons.get('oemSku')]],
    ['RestrictedForCustomer', [this.buttons.get('remove')]],
    ['DiscontinuedSuperseded', [this.buttons.get('remove'), this.buttons.get('supersede')]],
    ['RestrictedSuperseded', [this.buttons.get('remove'), this.buttons.get('supersede')]],
    ['PriceNotFound', [this.buttons.get('remove')]],
    ['Superseded', [this.buttons.get('remove'), this.buttons.get('supersede')]],
    ['Backorder', [this.buttons.get('ignore')]],
    ['Kit', [this.buttons.get('empty')]],
    ['PromoPrice', [this.buttons.get('empty')]],
    ['CustomPrice', [this.buttons.get('empty')]],
    ['CustomTool', [this.buttons.get('edit'), this.buttons.get('remove')]],
    ['ExpiredPrice', [this.buttons.get('remove')]],
    ['MinimumQuantity', [this.buttons.get('update')]],
    ['RefusePurchase', [this.buttons.get('remove')]],
  ]);

  ignoreNotificationUrl = '/api/notification/ignore';
  itemizeLineNotesUrl = '/api/notification/itemizelinenotes';
  itemizeUrl = '/api/notification/itemize';
  productListUrl = '/api/product/list';
  promoPriceUrl = '/api/notification/promoprice';

  constructor(
    private apiService: ApiService,
    private quoteToolsService: QuoteToolsService
  ) { }

  parseToolNotifications(tool: Product, templateValues): TooltipNotification {
    tool.notifications.forEach(notice => {
      notice.buttons = this.generateButtonsForNotice(notice, templateValues);
    });
    return prioritizeNotifications(tool.notifications, templateValues.NotificationMessageType);
  }

  private generateButtonsForNotice(notification, templateValues) {
    const notificationCode = templateValues.NotificationMessageCode[notification.messageCodeId];
    return this.messageButtons.has(notificationCode) ? this.messageButtons.get(notificationCode) : [this.buttons.get('empty')];
  }

  keepAsSetAndItemizeLineNotes(tool: Product, notificationId) {
    this.apiService.post(this.itemizeLineNotesUrl, { id: notificationId })
      .subscribe(updatedProduct => {
        tool.lineNotes.bomNotes = updatedProduct.lineNotes.bomNotes;
        tool.notifications = updatedProduct.notifications;
        this.quoteToolsService.setNotificationIcon(tool);
      });
  }

  itemizeSet(payload) {
    return this.apiService.post(this.itemizeUrl, payload);
  }

  usePromoPrice(notificationId) {
    return this.apiService.post(this.promoPriceUrl, { id: notificationId });
  }
}
